import React, { Component } from "react";
import Slider from 'react-slick';



export class Banner extends Component {
    state = {
        show: false,
      }
      render() {
        var slick_slider = {
          dots: false,
          arrow: false,
          autoplay: true,
          infinite: true,
          speed: 1000,
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 1,
  
          responsive: [{
  
            breakpoint: 1199,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1
            }
        },
        {
      
            breakpoint: 1024,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1
            }
        },
        {
      
            breakpoint: 680,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
        };
               
        return (
                
            <Slider className="slick_slider banner_slider banner_slider_3" {...slick_slider} slidesToShow={1} autoplay={false} fade="true" >
              <div className="slide bg-layer">
                {/* <div className="slide_img" style={{ backgroundImage: 'url(https://via.placeholder.com/1920x730?text=slider-mainbg-005-1920x730.jpg)' }}></div> */}
                <div className="slide_img" style={{ backgroundImage: 'url(images/slides/Slide1.png)' }}></div>
                <div className="slide__content pb-50 pb-xl-0 pt-130 pt-xl-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-8">
                                <div className="slide__content--headings ttm-textcolor-white">
                                    <h2  className="animated animate__fadeInDown">  <span className="text-theme-SkinColor fw-normal"><strong> Atlas </strong> </span> Your Trusted </h2>
                                    <h2  className="animated animate__fadeInDown">Partner  in <span className="text-theme-SkinColor fw-normal"> <strong>Talent</strong>  </span>  Acquisition </h2>
                                    <div className="mt-20 mb-30 mb-md-15">
                                        <p  className="animated animate__fadeInDown d-none d-md-block">
                                        With a dedication to excellence and custom-tailored solutions, Atlas stands as your ultimate destination for adept personnel spanning various industries, ensuring reliability, expertise and <span className="text-theme-SkinColor fw-normal"><strong>our commitment to Quality, Health, Safety & Environment </strong></span>with each endeavour.</p>
                                        
                                    </div>
                                    <div className="animated animate__fadeInUp" data-delay="1.4">
                                        <a className="ttm-btn ttm-btn-size-md ttm-btn-shape-rounded ttm-btn-style-fill ttm-btn-color-skincolor" 
                                        href={process.env.PUBLIC_URL + '/contact_01'}>Contact us</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="d-none d-xl-block text-center position-relative">
                                    <div className="z-index-1 position-relative">
                                      <img  className="rounded-circle box-shadow m-auto img-fuild" src="images/slides/single01-332x332.png" alt=""></img>
                                    </div>
                                    <div className="cmp-logo one">
                                        <img className="img-fluid" src="images/Career/1.png" alt="" />
                                    </div>
                                    <div className="cmp-logo two">
                                        <img className="img-fluid" src="images/Career/2.png" alt="" />
                                    </div>
                                    <div className="cmp-logo three">
                                        <img className="img-fluid" src="images/Career/3.png" alt="" />
                                    </div>
                                    <div className="cmp-logo four">
                                        <img className="img-fluid" src="images/Career/4.png" alt="" />
                                    </div>
                                    <div className="cmp-logo five">
                                        <img className="img-fluid" src="images/cat-icon4.png" alt="" />
                                    </div>
                                    <div className="arrow-one">
                                        <img src="images/slides/arrow-111.png" alt="" />
                                    </div>
                                    <div className="arrow-two">
                                        <img src="images/slides/arrow-222.png" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </Slider>
            
        )
    }
}

export default Banner;